<template>
  <div :id="value.answerId" class="fill-type-wrapper">
    <div v-if="value.optionTitle" :class="['fill-title', {'is-detail': isDetail}]">
      {{ value.optionTitle }} 
      <span v-if="value.answerType === 2 && !isDetail" class="not-require">（选填） </span>
    </div>
    <div v-if="isDetail && value.memberOptionContent" class="fill-area-detail">
      {{ value.memberOptionContent }}
    </div>
    <van-field
      v-else-if="!isDetail"
      v-model="value.memberOptionContent"
      :rows="3"
      type="textarea"
      maxlength="500"
      placeholder="我们期待收到您的任何反馈"
      class="fill-textarea"
      :show-word-limit="true"
    />
  </div>
</template>

<script>
export default {
  name: 'FillType',
  props: {
    value: {
      type: Object,
      default() {}
    },
    isDetail: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      quesData: this.value,
    };
  },
  created() {},
  methods: {}
}
</script>

<style lang="scss" scoped>
.fill-type-wrapper {
  .fill-title {
    margin: 0 0 16px 0;
    font-size: 24px;
    line-height: 32px;
    color: #666;
    &.is-detail {
      color: #ACACAC;
    }
  }
  .not-require {
    margin-left: 10px;
    font-weight: 400;
    line-height: 32px;
    font-size: 24px;
    color: #999;
  }
  .fill-area-detail {
    font-size: 24px;
    line-height: 40px;
    color: #3a3b3c;
    background: #f8f8f8;
    border-radius: 16px;
    padding: 16px 24px;
  }
  .fill-textarea {
    width: 100%;
    background: #F8F8F8;
    border-radius: 16px;
    padding: 16px 24px;
  }
  :deep(.van-field__word-limit) {
    // font-size: 24px;
    color: #ACACAC;
  }
  :deep(.van-field__control) {
    font-size: 24px;
    color: #3a3b3c;
    line-height: 40px;
    &::placeholder {
      line-height: 40px;
    }
  }
}
</style>
